module.exports = "<datepicker\n    class=\"{{ vm.class }}\"\n    ng-model=\"vm.dateModel\"\n    ng-change=\"vm.onDateChange()\"\n    ng-disabled=\"vm.ngDisabled\"\n    options=\"vm.options\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/datepicker/api/template.html
// module id = 1597
// module chunks = 0